import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { SubscriptionData } from '../../account/subscription-data.model'
import { AccountClient } from '../../account/account.client'

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  public subscriptionData$ = new BehaviorSubject<SubscriptionData | undefined>(
    undefined,
  )

  constructor(private accountClient: AccountClient) {}

  public async fetchSubscriptionData(): Promise<void> {
    const result = await this.accountClient.getSubscriptionInfo()

    if (result.err) {
      // Silently fail - components can handle errors if needed
      this.subscriptionData$.next(undefined)
      return
    }

    this.subscriptionData$.next(result.safeUnwrap())
  }

  public clearSubscriptionData(): void {
    this.subscriptionData$.next(undefined)
  }

  public get subscriptionData(): SubscriptionData | undefined {
    return this.subscriptionData$.value
  }

  public get hasValidSubscription(): boolean {
    return (this.subscriptionData?.allowedStudentCount ?? 0) >= 1
  }
}
